const awsmobile = {
  Auth: {
    region: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_HlLV2pytR',
    userPoolWebClientId: '4db5m53von4ikmuj79hnebfvg3', 
    // OPTIONAL - customized storage object
    //storage: window.sessionStorage,
  }
}

export default awsmobile
